<span class="closeModal pull-right" (click)="cancelar()"><i class="fa fa-times"></i></span>
<h1 mat-dialog-title>Avance de Ficha Médica</h1>
<mat-dialog-content class="mat-card-content overflow">
  <div #mydiv></div>
  <section>
    <mat-error *ngIf="fichaInvalida" class="fichaInvalida">{{MensajeError}}</mat-error>
    <form class="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="row" hidden="true">
            <input formControlName="id" name="id" type="text" class="form-control" />
            <input formControlName="fichaMedica" name="fichaMedica" type="text" class="form-control" />
        </div>
      
        <div class="row">
            <div class="col-lg-6">
                <label class="col-form-label font-bold" for="desde">Fecha</label>
                <div class="">
                    <p-calendar [appendTo]="mydiv" selectOtherMonths="true" formControlName="fecha" dateFormat="dd/mm/yy" inputId="fecha" selectOtherMonths="true" ngDefaultControl></p-calendar>
                    <div *ngIf="registerFormControl.fecha.errors?.required && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">La Fecha es Requerida</div>
                </div>
            </div>
            <div class="col-lg-6">
            </div>
        </div>

        <div class="form-group">
            <label class=" col-form-label font-bold">Avance</label>
            <textarea rows="3" formControlName="avance" maxlength="500" name ="selectedAvance" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.avance.errors && (registerFormControl.avance?.dirty || registerFormControl.avance?.touched || submitted)}"></textarea>
            <!-- <input formControlName="avance" maxlength="500" name ="selectedAvance" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.avance.errors && (registerFormControl.avance?.dirty || registerFormControl.avance?.touched || submitted)}"/> -->
            <mat-error  class="text-danger"*ngIf="registerFormControl.avance.errors?.required && (registerFormControl.avance?.dirty || registerFormControl.avance?.touched || submitted)">
                El Avance es Requerido
            </mat-error>
        </div>
        <br>
        <div class="buttons">
            <button mat-button type="button" (click)="cancelar()" class="button">Cerrar</button>
            <button *ngIf="permisoEdicion" mat-button type="submit" class="btn btn-primary">Guardar</button>
        </div>

    </form>
  </section>
</mat-dialog-content>
